import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getConfiguration } from '@/store/slices/userSlice'

const permissionActions = ['Create', 'Update', 'Delete', 'GetList']

const defaultPermission = permissionActions.reduce((result, action) => {
  result[action] = true
  return result
}, {})

const hasPermission = (permission, grantedPolicies) => {
  if (!permission) return true
  if (!grantedPolicies) return false
  if (permission.indexOf('.*') >= 0) {
    const permissionPrefix = permission.replace('*', '')
    for (const key in grantedPolicies) {
      if (grantedPolicies[key] && key.indexOf(permissionPrefix) === 0) {
        return true
      }
    }
    return false
  }
  return !!grantedPolicies[permission]
}

const hasAnyResourcePermission = (permission, grantedPolicies) => {
  if (!permission || !grantedPolicies) return false
  const prefix = `${permission}.`
  for (const key in grantedPolicies) {
    if (grantedPolicies[key] && key.indexOf(prefix) === 0) {
      return true
    }
  }
  return false
}

export const usePermission = (permission) => {
  const configuration = useSelector(getConfiguration)
  return useMemo(() => {
    if (!permission) return defaultPermission
    const grantedPolicies = configuration?.auth?.grantedPolicies
    const result = permissionActions.reduce((acc, action) => {
      acc[action] = hasPermission(`${permission}.${action}`, grantedPolicies)
      return acc
    }, {})
    // 拥有该资源任一操作权限时，默认具备列表查询权限
    result.GetList =
      result.GetList || hasAnyResourcePermission(permission, grantedPolicies)
    return result
  }, [configuration, permission])
}

export default usePermission
